module.exports = {
  "id": "beetle",
  "title": "beetle",
  "image": "provision/parts/beetle/beetle.png",
  "info": [
    {
      "text": "Add a beetle to your project",
      "image": "provision/parts/beetle/beetle.png"
    }
  ],
  "exposedVariables": [],
  "codeImage": "provision/parts/beetle/beetle.png"
} ;